import { Button } from "antd";
import React, { Component } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "./OrderDone.scss";

class OrderDone extends Component {
  render() {
    const {location : {state}} = this.props;
    return (
      <div className="order-done-wrapper">
        <div className="container">
          <div className="order-done-ccontent">
            <i>
              <FaCheckCircle />
            </i>
            <h2 className="order-done-title">تم اضافه الطلب بنجاح</h2>
            <p className="order-done-p">
              يمكنك مراجعه الطلب المضاف من خلال عرض الطلب او اضافه طلب جديد
            </p>
            <div className="order-done-btns">
              <Button type="primary" size="large">
                <Link to={{pathname:"/client", state:{orderId : state?.orderId}}} style={{justifyContent : "center"}}> عرض الطلب </Link>
              </Button>
              <Button type="primary" size="large" ghost>
                <Link style={{justifyContent : "center"}} to="/finance"> طلب جديد </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect()(OrderDone);  